function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { RouteType, useSdkContext } from "~/components/contexts";
import IconAlertCircle from "./icon-alert-circle.svg";
import { Button, Container, Content, Description, IconContainer, Text, Wrapper } from "./styles";
export const PrintEditionFooter = ({
  config,
  ...props
}) => {
  const {
    buttonText,
    desc,
    text,
    url
  } = config;
  const {
    handleRoutePush
  } = useSdkContext();
  return /*#__PURE__*/React.createElement(Container, _extends({}, props, {
    "data-qa": "print-edition-footer"
  }), /*#__PURE__*/React.createElement(Wrapper, {
    onClick: () => {
      void handleRoutePush(url, {
        query: {
          module: "covid-19_update_footer",
          pgtype: "homepage"
        },
        type: RouteType.Article
      });
    }
  }, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(IconContainer, null, /*#__PURE__*/React.createElement(IconAlertCircle, null)), /*#__PURE__*/React.createElement(Text, {
    dangerouslySetInnerHTML: {
      __html: text
    }
  })), /*#__PURE__*/React.createElement(Description, null, desc), /*#__PURE__*/React.createElement(Button, null, buttonText)));
};
PrintEditionFooter.displayName = "PrintEditionFooter";